import React from 'react';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Field, isDirty, reduxForm } from 'redux-form';

import Typography from '@material-ui/core/Typography';

import { FormActionButtons, Input } from 'components';

import { useStyles } from './styles';

const initialValues = {
  id: '',
  googleAnalyticsId: ''
};

const GoogleAnalyticsForm = ({ handleSubmit, isDirty }) => {
  const classes = useStyles();
  const [t] = useTranslation();

  return (
    <div className={classes.wrapper}>
      <Typography variant="h1" className={classes.title}>
        {t('Google analytics settings')}
      </Typography>
      <form onSubmit={handleSubmit}>
        <Field
          name="googleAnalyticsId"
          className={classes.input}
          inputProps={{ maxLength: 255 }}
          placeholder="Google analytics tracking id"
          label="Google analytics tracking id *"
          component={Input}
        />
        <FormActionButtons
          isDisabledAction={!isDirty}
          cancelPath="/"
          actionLabel="Save"
        />
      </form>
    </div>
  );
};

const mapStateToProps = state => ({
  isDirty: isDirty('googleAnalyticsForm')(state)
});

export default reduxForm({
  form: 'googleAnalyticsForm',
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: false,
  touchOnBlur: false,
  initialValues
})(connect(mapStateToProps)(GoogleAnalyticsForm));
